module.exports = __webpack_public_path__ + "static/media/backrise-30.33aa392e.png";